import { render } from "./TipoEquipamentoSelect.vue?vue&type=template&id=b25a0ff2"
import script from "./TipoEquipamentoSelect.vue?vue&type=script&lang=js"
export * from "./TipoEquipamentoSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__